import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";
import trasportApi from "../../api/trasportApi";
import moment from "moment-timezone";
import { Row, Col, Table, Form, Button, Container } from "react-bootstrap";
import Select from "react-select";
import csvDownload from "json-to-csv-export";
import jwt_decode from "jwt-decode";
import Main from "../layout/Main";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";

const ViewTaskReports = (props) => {
  console.log("props", props);
  const location = useLocation();
  const [state, setState] = useState(location.state ? location.state : {});
  const [reports, setReports] = useState([]);
  const [lead, setlead] = useState([]);
  const [leadActivityReport, setleadActivityReport] = useState([]);

  const [tempdata, settempdata] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [tempLabelss, setTempLabels] = useState([]);
  const [isDisable, setDisable] = useState(true);

  const [selectedTrasport, setSelectedTrasport] = useState();
  const [optionTrasportaion, setTrasportaionsOption] = useState([]);

  const [selectedBranch, setSelectedBranch] = useState();
  const [optionBranch, setBranchOption] = useState([]);

  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isAllFnSelected, setIsAllFnSelected] = useState(false);

  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [optionFinancialYear, setOptionFinancialYear] = useState([]);

  const [selectedSupplier, setSelectedSupplier] = useState();
  const [optionSupplier, setOptionSupplier] = useState([]);

  const [userInfo, setUserInfo] = useState(
    jwt_decode(localStorage.getItem("token"))
  );

  const fetchAllUsers = async () => {
    const trasportRec = await trasportApi.fetchAllTransporters();
    const branchRec = await trasportApi.fetchAllBranch();
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    const suppliers = await trasportApi.fetchAllSupplier();

    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });
       // Add "Select All" option at the beginning
        ar.unshift({ value: "all", label: "Select All" });
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }

    //Trasport Api
    if (trasportRec && trasportRec.length) {
      let ar = [];
      trasportRec.forEach((item) => {
        ar.push({
          value: item.id,
          label: item.transporter_name,
        });
      });
      setTrasportaionsOption(ar);
    } else {
      setTrasportaionsOption([]);
    }

    //Supplier Api
    if (suppliers && suppliers.length) {
      let ar = [];
      suppliers.forEach((item) => {
        ar.push({
          value: item.id,
          label: item.name,
        });
      });
      setOptionSupplier(ar);
    } else {
      setOptionSupplier([]);
    }

    //Branch Api
    if (branchRec && branchRec.length) {
      let ar = [];
      branchRec.forEach((item) => {
        ar.push({
          value: item.id,
          label: item.branch_name,
        });
      });
      setBranchOption(ar);
    } else {
      setBranchOption([]);
    }
  };

  let tempLabels;
  useEffect(() => {
    fetchAllReportHistory();
    console.log("1 Supplier_Report");
  }, []);

  const fetchAllReportHistory = async () => {
    console.log("statestatestate", state);
    console.log(
      "Is Supplier_Report ????????????????????????",
      state.apiName === "supplierreports"
    );
    if (
      state.apiname === "supplierreports" ||
      state.apiname === "transportvehiclereport" ||
      state.apiname === "tripaveragereport" ||
      state.apiname === "transportvehiclereportnew" ||
      state.apiname === "trasporterdetailreport"
    ) {
      console.log("In Final Condition", state.apiname);
      let result = await trasportApi.fetchReports(state);
      console.log("23", result);
      try {
        if (result && result.length > 0) {
          let filterdata = result;
          console.log("filterdata@@@@@@@@", filterdata);
          tempLabels = Object.keys(filterdata[0]);
          console.log("tempLabels@@@@@@@@", tempLabels);
          setTempLabels(tempLabels);
          setReports(filterdata);
          settempdata(filterdata);
          const headers = Object.keys(filterdata[0]).map((key) => ({
            prop: key,
            title: key,
          }));
          console.log("headers", headers);
          setHeaders(headers);
        } else {
          setleadActivityReport([]);
          //   window.alert("No Data available");
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }
  };

  const fetchAllData = async () => {
    // console.log("Stateee", state);

    let result;
    let filterdata;
    let tempHeaders;

    // Fetch data based on `state.apiname`
    if (
      state.apiname === "transportvehiclereport" ||
      state.apiname === "transportvehiclereportnew" ||
      state.apiname === "tripaveragereport" ||
      state.apiname === "trasporterdetailreport" ||
      state.apiname === "supplierreports"
    ) {
      try {
        result = await trasportApi.fetchReports(state);

        if (result && result.length > 0) {
          filterdata = result;
          console.log("filterdata", filterdata);
          setReports(result);
          settempdata(filterdata);

          // Dynamically setting headers based on the `state.apiname`
          tempHeaders = Object.keys(filterdata[0]).map((key) => ({
            prop: key,
            title: key,
          }));
          setHeaders(tempHeaders);
          console.log("headers", tempHeaders);
        } else {
          setReports([]); // Empty reports when no data is returned
          settempdata([]);
          window.alert("No Data available");
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [state.apiname, tempLabelss]); // Fetch data when `state.apiname` changes

  useEffect(() => {
    fetchAllUsers();
  }, []);

  // Excel Download Method.
  const exportExcel = async () => {
    if (
      !reports ||
      !Array.isArray(reports) ||
      !tempLabelss ||
      !Array.isArray(tempLabelss)
    ) {
      console.error("Reports or tempLabels are not properly defined.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // ✅ Add Centered Heading
    const titleRow = worksheet.addRow([state.reportname]);
    titleRow.font = { bold: true, size: 14 };
    titleRow.alignment = { horizontal: "center", vertical: "middle" };
    worksheet.mergeCells("A1:D1");

    // ✅ Add From Date - To Date Row (Bind actual values later)
    const dateRow = worksheet.addRow([
      "From Date:",
      state.fromDate ? state.fromDate : "",
      "To Date:",
      state.todate ? state.todate : "",
    ]); // Bind values here
    dateRow.alignment = { horizontal: "left", vertical: "middle" };

    // ✅ Add Branch Name - Financial Year - Transporter/Supplier Name Row (Bind actual values later)
    const branchRow = worksheet.addRow([
      "Branch Name:",
      selectedBranch?.label ? selectedBranch?.label : "",
      "Financial Year:",
      selectedFinancialYear?.label ? selectedFinancialYear?.label : "",
      "Transporter/Supplier Name",
      selectedTrasport?.label
        ? selectedTrasport?.label
        : selectedSupplier?.label,
    ]); // Bind values here
    branchRow.alignment = { horizontal: "left", vertical: "middle" };

    // ✅ Convert headers: Remove underscores & capitalize
    const formattedHeaders = tempLabelss.map((label) =>
      label.replace(/_/g, " ").toUpperCase()
    );

    // ✅ Add Headers Row
    const headerRow = worksheet.addRow(formattedHeaders);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D3D3D3" },
      };
    });

    // ✅ Add Data Rows
    reports.forEach((row) => {
      worksheet.addRow(tempLabelss.map((key) => row[key] || ""));
    });

    // ✅ Compute Column Totals
    const totalRowData = tempLabelss.map((key) => {
      if (
        [
          "dispatch_weight",
          "rate",
          "freight",
          "commission",
          "total_advance_amount",
          "total_diesel_amount",
          "balance_amount",
        ].includes(key)
      ) {
        return reports.reduce(
          (sum, row) => sum + (parseFloat(row[key]) || 0),
          0
        );
      }
      // ✅ Special condition for "balance_amount" if state.apiname === "trasporterdetailreport"
      if (
        key === "balance_amount" &&
        state.apiname === "trasporterdetailreport"
      ) {
        return reports.reduce(
          (sum, row) => sum + (parseFloat(row[key]) || 0),
          0
        );
      }
      return "";
    });

    // ✅ Add Total Row
    const totalRow = worksheet.addRow([
      "Overall Total",
      ...totalRowData.slice(1),
    ]);
    totalRow.font = { bold: true };
    totalRow.alignment = { horizontal: "right", vertical: "middle" };
    totalRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF99" },
      }; // Light Yellow
    });

    // ✅ Auto-adjust column width
    worksheet.columns.forEach((column, i) => {
      let maxLength = formattedHeaders[i]?.length || 10;
      reports.forEach((row) => {
        let value = row[tempLabelss[i]] ? row[tempLabelss[i]].toString() : "";
        if (tempLabelss[i] === "challan_date" && value) {
          const dateObj = new Date(value);
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = dateObj.getFullYear();
          value = `${day}/${month}/${year}`;
        }
        maxLength = Math.max(maxLength, value.length);
      });
      column.width = maxLength + 2;
    });

    // ✅ Save the file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `${state.apiname}.xlsx`
    );
  };

  console.log("reports", reports);
  const ReportDataCSV = {
    data: reports,
    filename: state.apiname,
    delimiter: ",",
    headers: tempLabels,
  };

  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRowDetails = (rowId) => {
    console.log("rowid", rowId);
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  const handleSupplier = async (event) => {
    setSelectedSupplier(event);
    setState({ ...state, supplier_id: event.value });
    if (event) {
      let vecRec = await trasportApi.fetchAllVechicleBySupplierId(event.value);
      if (vecRec && vecRec.length) {
        let options = vecRec.map((item) => ({
          value: item.id,
          label: item.vehicle_number,
        }));

        // Add "Select All" option at the beginning
        options.unshift({ value: "all", label: "Select All" });

        setVehicleOptions(options);
        setDisable(false);
      } else {
        setVehicleOptions([]);
      }
    }
  };

  const handleTrasport = async (event) => {
    setSelectedTrasport(event);
    setState({ ...state, transporter_id: event.value });
    if (event) {
      let vecRec = await trasportApi.fetchAllVechicleByTrasporterId(
        event.value
      );
      if (vecRec && vecRec.length) {
        let options = vecRec.map((item) => ({
          value: item.id,
          label: item.vehicle_number,
        }));

        // Add "Select All" option at the beginning
        options.unshift({ value: "all", label: "Select All" });

        setVehicleOptions(options);
        setDisable(false);
      } else {
        setVehicleOptions([]);
      }
    }
  };

  const handleBranch = (selectedOption) => {
    setSelectedBranch(selectedOption);
    setState({ ...state, branch_id: selectedOption.value });
  };

  const handleVechicle = (selectedOptions) => {
    // Check if "Select All" is clicked
    if (selectedOptions.some((option) => option.value === "all")) {
      if (isAllSelected) {
        // If already selected, deselect all
        setSelectedVehicles([]);
        setIsAllSelected(false);
        setState({ ...state, vehicle_ids: [] });
      } else {
        // Select all options except "Select All" itself
        const allVehicles = vehicleOptions.filter(
          (option) => option.value !== "all"
        );
        setSelectedVehicles(allVehicles);
        setIsAllSelected(true);
        setState({ ...state, vehicle_ids: allVehicles.map((v) => v.value) });
      }
    } else {
      setSelectedVehicles(selectedOptions);
      setIsAllSelected(selectedOptions.length === vehicleOptions.length - 1); // Check if all selected
      setState({
        ...state,
        vehicle_ids: selectedOptions.map((option) => option.value),
      });
    }
  };

  const handleFinancialYear = (selectedOptions) => {
    // setSelectedFinancialYear(selectedOptions);
    // setState({ ...state, financial_year_id: selectedOptions.value });

    if (selectedOptions.some((option) => option.value === "all")) {
      if (isAllFnSelected) {
        // If already selected, deselect all
        setSelectedFinancialYear([]);
        setIsAllFnSelected(false);
        setState({ ...state, financial_year_id: [] });
      } else {
        // Select all options except "Select All" itself
        const allVehicles = optionFinancialYear.filter(
          (option) => option.value !== "all"
        );
        setSelectedFinancialYear(allVehicles);
        setIsAllFnSelected(true);
        setState({ ...state, financial_year_id: allVehicles.map((v) => v.value) });
      }
    } else {
      setSelectedFinancialYear(selectedOptions);
      setIsAllFnSelected(selectedOptions.length === optionFinancialYear.length - 1); // Check if all selected
      setState({
        ...state,
        financial_year_id: selectedOptions.map((option) => option.value),
      });
    }
  };

  const headerTransportvehiclereport = [
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Client Name", prop: "client_name", isFilterable: true },
    { title: "Branch Name", prop: "branch_name", isFilterable: true },
    {
      title: "Challan Date",
      prop: "challan_date",
      isSortable: true,
      isFilterable: true,
      // cell: (row) =>
      //   row.challan_date ? moment(row.challan_date).format("DD MMM, yyyy") : "",
    },
    {
      title: "Challan No",
      prop: "challan_no",
      isSortable: true,
      isFilterable: true,
    },
    { title: "Vehicle No", prop: "vehicle_number", isFilterable: true },
    { title: "GR No", prop: "g_r_no", isFilterable: true },
    { title: "Item Name", prop: "item_name", isFilterable: true },
    { title: "From Station", prop: "from_station_id", isFilterable: true },
    { title: "To Station", prop: "to_station_id", isFilterable: true },
    { title: "Dispatch Weight", prop: "dispatch_weight", isFilterable: true },
    { title: "Rate", prop: "rate", isFilterable: true },
    { title: "Freight", prop: "freight", isFilterable: true },
    { title: "Commission", prop: "commission", isFilterable: true },
    { title: "Advanced Amount", prop: "advance_amounts", isFilterable: true },
    { title: "Advanced Voucher", prop: "adv_voucher", isFilterable: true },
    {
      title: "Total Advanced",
      prop: "total_advance_amount",
      isFilterable: true,
    },
    { title: "Diesel Detail", prop: "diesel_details", isFilterable: true },
    { title: "Diesel Amounts", prop: "diesel_amounts", isFilterable: true },
    {
      title: "Total Diesel Detail",
      prop: "total_diesel_amount",
      isFilterable: true,
    },
    { title: "Labour", prop: "labour_amount", isFilterable: true },
    { title: "Balance", prop: "balance_amount", isFilterable: true },
    { title: "Actual Rate", prop: "actual_item_rate", isFilterable: true },
    {
      title: "Actual Freight",
      prop: "actual_total_freight",
      isFilterable: true,
    },
    { title: "Profit Amount", prop: "profit", isFilterable: true },
    { title: "Total Income", prop: "total_income", isFilterable: true },
    { title: "Created By", prop: "createdbyname", isFilterable: true },
    {
      title: "Last Modified By",
      prop: "lastmodifiedbyname",
      isFilterable: true,
    },
  ];

  const headerTransportvehiclereportnew = [
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Client Name", prop: "client_name", isFilterable: true },
    { title: "Branch Name", prop: "branch_name", isFilterable: true },
    {
      title: "Challan Date",
      prop: "challan_date",
      isSortable: true,
      isFilterable: true,
      // cell: (row) =>
        // row.challan_date ? new Date(row.challan_date).toLocaleDateString() : "",
        // row.challan_date ? moment(row.challan_date).format("DD MMM, yyyy") : "",
    },
    {
      title: "Challan No",
      prop: "challan_no",
      isSortable: true,
      isFilterable: true,
    },
    { title: "Vehicle No", prop: "vehicle_number", isFilterable: true },
    { title: "GR No", prop: "g_r_no", isFilterable: true },
    { title: "Item Name", prop: "item_name", isFilterable: true },
    { title: "From Station", prop: "from_station_id", isFilterable: true },
    { title: "To Station", prop: "to_station_id", isFilterable: true },
    { title: "Dispatch Weight", prop: "dispatch_weight", isFilterable: true },
    { title: "Rate", prop: "rate", isFilterable: true },
    { title: "Freight", prop: "freight", isFilterable: true },
    { title: "Commission", prop: "commission", isFilterable: true },
    { title: "Advanced Amount", prop: "advance_amounts", isFilterable: true },
    { title: "Advanced Voucher", prop: "adv_voucher", isFilterable: true },
    {
      title: "Total Advanced",
      prop: "total_advance_amount",
      isFilterable: true,
    },
    { title: "Diesel Detail", prop: "diesel_details", isFilterable: true },
    { title: "Diesel Amounts", prop: "diesel_amounts", isFilterable: true },
    {
      title: "Total Diesel Detail",
      prop: "total_diesel_amount",
      isFilterable: true,
    },
    { title: "Labour", prop: "labour_amount", isFilterable: true },
    { title: "Balance", prop: "balance_amount", isFilterable: true },
    { title: "Created By", prop: "createdbyname", isFilterable: true },
    {
      title: "Last Modified By",
      prop: "lastmodifiedbyname",
      isFilterable: true,
    },
  ];

  const headerTripreport = [
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Client Name", prop: "client_name", isFilterable: true },
    { title: "Branch Name", prop: "branch_name", isFilterable: true },
    {
      title: "Challan Date",
      prop: "challan_date",
      isSortable: true,
      isFilterable: true,
      // cell: (row) =>
      //   row.challan_date ? moment(row.challan_date).format("DD MMM, yyyy") : "",
    },
    {
      title: "Challan No",
      prop: "challan_no",
      isSortable: true,
      isFilterable: true,
    },
    { title: "Vehicle No", prop: "vehicle_number", isFilterable: true },
    { title: "GR No", prop: "g_r_no", isFilterable: true },
    { title: "Item Name", prop: "item_name", isFilterable: true },
    { title: "From Station", prop: "from_station_id", isFilterable: true },
    { title: "To Station", prop: "to_station_id", isFilterable: true },
    { title: "Dispatch Weight", prop: "dispatch_weight", isFilterable: true },
    { title: "Rate", prop: "rate", isFilterable: true },
    { title: "Freight", prop: "freight", isFilterable: true },
    { title: "Commission", prop: "commission", isFilterable: true },
    { title: "Advanced Amount", prop: "advance_amounts", isFilterable: true },
    { title: "Advanced Voucher", prop: "adv_voucher", isFilterable: true },
    {
      title: "Total Advanced",
      prop: "total_advance_amount",
      isFilterable: true,
    },
    { title: "Diesel Detail", prop: "diesel_details", isFilterable: true },
    { title: "Diesel Amounts", prop: "diesel_amounts", isFilterable: true },
    {
      title: "Total Diesel Detail",
      prop: "total_diesel_amount",
      isFilterable: true,
    },
    { title: "Labour", prop: "labour_amount", isFilterable: true },
    { title: "Balance", prop: "balance_amount", isFilterable: true },
    { title: "Trip Start (KM)", prop: "trip_start_km", isFilterable: true },
    { title: "Trip End (KM)", prop: "trip_end_km", isFilterable: true },
    {
      title: "Trip Running Trip (Km)",
      prop: "trip_running_km",
      isFilterable: true,
    },
    { title: "Trip Average", prop: "trip_average", isFilterable: true },
    { title: "Created By", prop: "createdbyname", isFilterable: true },
    {
      title: "Last Modified By",
      prop: "lastmodifiedbyname",
      isFilterable: true,
    },
  ];

  const headerTransportreport = [
    {
      title: "Transporter Name",
      prop: "transporter_name",
      isFilterable: true,
    },
    { title: "Trasporter Phone", prop: "phone", isFilterable: true },

    { title: "Balance", prop: "balance", isFilterable: true },
    {
      title: "FINANCIAL YEAR NAME",
      prop: "FINANCIAL_YEAR_NAME",
      isFilterable: true,
    },
  ];

  const headerSupllierReport = [
    {
      title: "Challan Diesel Date",
      prop: "challan_diesel_advance_date",
      isSortable: true,
      isFilterable: true,
      // cell: (row) =>
      //   row.challan_diesel_advance_date
      //     ? moment(row.challan_diesel_advance_date).format("DD MMM, yyyy")
      //     : "",
    },
    { title: "Supplier Name", prop: "suppliers", isFilterable: true },

    { title: "Transporter Name", prop: "transporters", isFilterable: true },
    { title: "Vehicles Name", prop: "vehicles", isFilterable: true },

    { title: "Total Qty", prop: "total_qty", isFilterable: true },
    { title: "Rate", prop: "rate", isFilterable: true },

    { title: "Total Amount", prop: "total_amount", isFilterable: true },
    { title: "Remark", prop: "remarks", isFilterable: true },

    {
      title: "FINANCIAL YEAR NAME",
      prop: "financial_year_name",
      isFilterable: true,
    },
  ];

  console.log("Data Body", reports);

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape", // Wider page for more columns
      unit: "mm",
      format: "a4", // A4 paper
    });

    // Set Heading (Company Name) - Bold, Font Size 18, and Centered
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    let heading = userInfo.companyname;
    const headingWidth =
      (doc.getStringUnitWidth(heading) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    doc.text(heading, (doc.internal.pageSize.width - headingWidth) / 2, 12); // Center heading

    // Add one line space after heading
    const spaceAfterHeading = 6; // Line space after heading (adjust as needed)

    // Title (Center Aligned and Bold)
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    const title = "Transport Vehicle Report";
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    doc.text(
      title,
      (doc.internal.pageSize.width - titleWidth) / 2,
      18 + spaceAfterHeading
    ); // Center title below the heading

    // Transporter Name and Vehicle Number (Next Line)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    const transporterName = selectedTrasport?.label || "";
    const vehicleNumbers =
      selectedVehicles?.map((v) => v.label).join(", ") || "";

    // Add transporter name on the left side if available
    if (transporterName) {
      doc.text(`Transporter: ${transporterName}`, 14, 26 + spaceAfterHeading);
    }

    // Add vehicle number on the right side of the same line if available
    // if (vehicleNumbers) {
    //   const vehicleX =
    //     doc.internal.pageSize.width -
    //     40 -
    //     (doc.getStringUnitWidth(vehicleNumbers) * doc.internal.getFontSize()) /
    //       doc.internal.scaleFactor;
    //   doc.text(`Vehicle: ${vehicleNumbers}`, vehicleX, 26 + spaceAfterHeading);
    // }

    // Today's date (India Format: DD-MM-YYYY)
    // const todayDate = new Date().toLocaleDateString("en-IN");
    const fromDate = state.fromdate;
    const toDate = state.todate;
    doc.text(
      `From Date: ${fromDate ? fromDate : ""}    To Date: ${
        toDate ? toDate : ""
      }`,
      14,
      34 + spaceAfterHeading
    );

    // Define table headers
    const headers = [
      [
        "S:NO",
        "Challan Date",
        "Challan No",
        "Vehicle",
        "GR.No",
        "Item",
        "From",
        "To",
        "Weight",
        "Rate",
        "Freight",
        "Comm",
        "Adv. Amt",
        "Adv. Vchr",
        "Total Adv.",
        "Diesel. Vchr",
        "Diesel Amt.",
        "Total Diesel",
        "Labour",
        "Balance",
      ],
    ];

    // Format numbers with commas
    const formatNumber = (num) => {
      if (num !== null && num !== undefined && !isNaN(num)) {
        return new Intl.NumberFormat().format(num);
      }
      return "";
    };

    const formatAmount = (amount) => {
      return amount
        .replace(/[₹¹]/g, "") // Remove the rupee symbol and unwanted characters like '¹'
        .replace(/(,)?\s*\n/g, ",\n") // Replace newline with comma but avoid adding an extra comma if one already exists
        .replace(/,\s*$/, "") // Remove trailing comma if present at the end
        .trim(); // Clean any extra spaces
    };

    // Map data
    console.log("PDF Report Data", reports);

    const data = reports.map((row, index) => [
      index + 1, // Keep the S:NO as index + 1
      // new Date(row.challan_date).toLocaleDateString(),
      row.challan_date,
      row.challan_no,
      row.vehicle_number,
      row.g_r_no,
      row.item_name,
      row.from_station_id,
      row.to_station_id,
      row.dispatch_weight,
      row.rate,
      formatNumber(row.freight), // Formatting number with commas
      row.commission,
      // parseFloat(
      //   (row.advance_amounts || "0").toString().replace(/[^\d.]/g, "")
      // ), // Remove currency symbols
      row.advance_amounts ? formatAmount(row.advance_amounts) : "0",
      row.adv_voucher || "",
      formatNumber(row.total_advance_amount || 0), // Formatting number with commas
      row.diesel_details || "",
      row.diesel_amounts ? formatAmount(row.diesel_amounts) : "0",
      // row.diesel_amounts || "0",
      formatNumber(row.total_diesel_amount || 0), // Ensure valid number formatting
      formatNumber(row.labour_amount || 0), // Formatting number with commas
      formatNumber(row.balance_amount || 0), // Formatting number with commas
    ]);

    // Calculate totals
    const totalFreight = reports.reduce(
      (sum, row) => sum + (parseFloat(row.freight) || 0),
      0
    );
    const totalAdvAmt = reports.reduce(
      (sum, row) => sum + (parseFloat(row.advance_amounts) || 0),
      0
    );
    const totalAdvVchr = reports.reduce(
      (sum, row) => sum + (parseFloat(row.total_advance_amount) || 0),
      0
    );
    const totalDieselAmt = reports.reduce(
      (sum, row) => sum + (parseFloat(row.diesel_amounts) || 0),
      0
    );
    const totalDiesel = reports.reduce(
      (sum, row) => sum + (parseFloat(row.total_diesel_amount) || 0),
      0
    );
    const totalLabour = reports.reduce(
      (sum, row) => sum + (parseFloat(row.labour_amount) || 0),
      0
    );
    const totalBalance = reports.reduce(
      (sum, row) => sum + (parseFloat(row.balance_amount) || 0),
      0
    );

    // Add total row
    data.push([
      "TOTAL",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      formatNumber(totalFreight),
      "", // Commission
      formatNumber(totalAdvAmt),
      "", // Adv. Voucher
      formatNumber(totalAdvVchr),
      "", // Diesel Voucher
      formatNumber(totalDieselAmt),
      formatNumber(totalDiesel),
      formatNumber(totalLabour),
      formatNumber(totalBalance),
    ]);

    // Generate table
    doc.autoTable({
      head: headers,
      body: data,
      startY: 40 + spaceAfterHeading, // Adjust startY to place table below the header section
      styles: {
        fontSize: 8, // Reduce text size
        cellPadding: 0.5,
        overflow: "linebreak", // Prevent text from breaking out
      },
      columnStyles: {
        0: { cellWidth: "auto" }, // Auto-adjust width for each column
        1: { cellWidth: "auto" },
        2: { cellWidth: "auto" },
        3: { cellWidth: "auto" },
        4: { cellWidth: "auto" },
        5: { cellWidth: "auto" },
        6: { cellWidth: "auto" },
        7: { cellWidth: "auto" },
        8: { cellWidth: "auto" },
        9: { cellWidth: "auto" },
        10: { cellWidth: "auto" },
        11: { cellWidth: "auto" },
        12: { cellWidth: "auto" },
        13: { cellWidth: "auto" },
        14: { cellWidth: "auto" },
        15: { cellWidth: "auto" },
        16: { cellWidth: "auto" },
        17: { cellWidth: "auto" },
        18: { cellWidth: "auto" },
        19: { cellWidth: "auto" },
        20: { cellWidth: "auto" },
      },
      theme: "grid",
      margin: { top: 40, left: 5, right: 5 }, // Reduce margins for max width
      tableWidth: "auto", // Fit columns within A4 width
      didDrawCell: (data) => {
        if (data.row.index === data.table.body.length - 1) {
          data.cell.styles.fillColor = [255, 255, 153]; // Light yellow background
          data.cell.styles.textColor = [0, 0, 0]; // Black text color
          data.cell.styles.fontStyle = "bold"; // Make text bold for better visibility
        }
      },
    });

    // Save PDF
    doc.save("transport_vehicle_report.pdf");
  };

  const CustomOption = (props) => {
    const { data, isSelected, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", padding: "5px" }}
      >
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          style={{ marginRight: "10px" }}
        />
        <label>{data.label}</label>
      </div>
    );
  };

  const formatApiName = (apiName) => {
    if (!apiName) return "";

    return apiName
      .replace(/([A-Z][a-z])/g, " $1") // Add space before capital letters followed by lowercase
      .replace(/_/g, " ") // Replace underscores with spaces
      .trim() // Remove extra spaces
      .toUpperCase(); // Convert to uppercase
  };

  //console.log('leads', lead)

  const labels = {
    beforeSelect: " ",
  };

  // const headerss =
  //   state.apiname === "transportvehiclereport" ? headerTransportvehiclereport : headerTransportvehiclereportnew
  //   state.apiname === "tripaveragereport" ? headerTripreport : ;

  const headerMappings = {
    transportvehiclereport: headerTransportvehiclereport,
    transportvehiclereportnew: headerTransportvehiclereportnew,
    tripaveragereport: headerTripreport,
    trasporterdetailreport: headerTransportreport,
    supplierreports: headerSupllierReport,
  };

  // Directly assign based on state.apiname
  const headerss = headerMappings[state.apiname];

  return (
    <Main>
      <Row className="justify-content-center text-center">
        <Col xs={12}>
          <h2 className="text-uppercase">{formatApiName(state.reportname)}</h2>
        </Col>
      </Row>

      <Row className="g-0">
        <Col lg={12} className="px-4 my-3">
          <Row className="mb-4">
            <Col xs={12} sm={6} lg={3}>
              <Form.Label htmlFor="fromDate">From Date</Form.Label>
              <Form.Control
                id="fromDate"
                type="date"
                value={state.fromDate}
                onChange={(e) =>
                  setState({ ...state, fromdate: e.target.value })
                }
                placeholder="From Date"
              />
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Label htmlFor="toDate">To Date</Form.Label>
              <Form.Control
                id="toDate"
                type="date"
                value={state.todate}
                onChange={(e) => setState({ ...state, todate: e.target.value })}
                placeholder="To Date"
              />
            </Col>
            {/* <Col xs={12} sm={6} lg={3}>
              <Form.Group className="mt-2">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicFinancialYear"
                >
                  Financial Year
                </Form.Label>
                <Select
                  name="financialYear"
                  value={selectedFinancialYear}
                  className="task-select"
                  onChange={handleFinancialYear}
                  options={optionFinancialYear}
                  getOptionValue={(option) => option.value}
                  isClearable
                />
              </Form.Group> */}
              <Col xs={12} sm={6} lg={3}>
              <Form.Group className="mt-2">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicVehicle"
                >
                  Financial Year
                </Form.Label>
                <Select
                  name="vehicle"
                  value={selectedFinancialYear}
                  className="task-select"
                  onChange={handleFinancialYear}
                  options={optionFinancialYear}
                  getOptionValue={(option) => option.value}
                  // isDisabled={isDisable}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option: CustomOption }}
                />
              </Form.Group>
            </Col>
            
            {state.apiname !== "supplierreports" && (
              <Col xs={12} sm={6} lg={3}>
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicOwner"
                  >
                    Transporter Name
                  </Form.Label>
                  <Select
                    name="transporter"
                    value={selectedTrasport}
                    className="task-select"
                    onChange={handleTrasport}
                    options={optionTrasportaion}
                    getOptionValue={(option) => option.value}
                    isClearable
                  />
                </Form.Group>
              </Col>
            )}
            {state.apiname === "supplierreports" && (
              <Col xs={12} sm={6} lg={3}>
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicOwner"
                  >
                    Supplier Name
                  </Form.Label>
                  <Select
                    name="supplier"
                    value={selectedSupplier}
                    className="task-select"
                    onChange={handleSupplier}
                    options={optionSupplier}
                    getOptionValue={(option) => option.value}
                    isClearable
                  />
                </Form.Group>
              </Col>
            )}
            <Col xs={12} sm={6} lg={3}>
              <Form.Group className="mt-2">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicVehicle"
                >
                  Vehicle Number
                </Form.Label>
                <Select
                  name="vehicle"
                  value={selectedVehicles}
                  className="task-select"
                  onChange={handleVechicle}
                  options={vehicleOptions}
                  getOptionValue={(option) => option.value}
                  isDisabled={isDisable}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option: CustomOption }}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Group className="mx-3">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicBranch"
                >
                  Branch Name
                </Form.Label>
                <Select
                  name="branch"
                  value={selectedBranch}
                  className="task-select"
                  onChange={handleBranch}
                  options={optionBranch}
                  getOptionValue={(option) => option.value}
                  isClearable
                />
              </Form.Group>
            </Col>

            <Col xs={12} sm={6} lg={3} style={{ marginTop: "28px" }}>
              <div className="d-flex flex-wrap gap-2">
                <Button onClick={fetchAllData}>Run Report</Button>

                <Button variant="warning" onClick={exportExcel}>
                  <i className="fa fa-file-csv me-1"></i> DownButtonCSV
                </Button>

                {state.apiname === "transportvehiclereportnew" && (
                  <Button variant="danger" onClick={downloadPDF}>
                    <i className="fa fa-file-pdf me-1"></i> Download PDF
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <Col lg={12} className="p-lg-4">
            {reports ? (
              <DatatableWrapper
                body={reports}
                headers={headerss}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 10,
                    options: [5, 10, 15, 20,50],
                  },
                }}
              >
                <Row className="mb-4">
                  <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                  >
                    <Filter />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-start align-items-center"
                  >
                    <PaginationOptions labels={labels} />
                    <InfoPill left="Total" right={reports?.length} />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                  ></Col>
                </Row>

                {/* Scrollable table with inline CSS */}
                <div
                  style={{
                    overflowX: "auto",
                    maxHeight: "60vh", // Adjust based on the desired height
                  }}
                >
                  <Table
                    striped
                    className="data-table"
                    style={{ minWidth: "100%" }}
                  >
                    <TableHeader />
                    <TableBody />
                  </Table>
                </div>

                <Pagination />
              </DatatableWrapper>
            ) : (
              <Container>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    😔 No Data Found
                  </span>
                </div>
              </Container>
            )}
          </Col>
        </Col>
      </Row>
    </Main>
  );
};

export default ViewTaskReports;
